import { makeStyles } from '@material-ui/core/styles'

export const wikiCategoryStyle = makeStyles(theme => ({
  backButton: {
    color: theme.palette.geoColors.headerText.main
  },
  backButtonIcon: {
    color: theme.palette.geoColors.headerText.main
  },
  backButtonPadding: {
    paddingLeft: theme.spacing(1)
  },
  divider: {
    height: 1,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    background: theme.palette.geoColors.contextBar.dark
  },
  documentItem: {
    '& .MuiTypography-body1': {
      fontSize: '0.9rem'
    }
  },
  list: {
    paddingBottom: 0
  },
  nestedListSubheader: {
    display: 'flex',
    flexDirection: 'row',
    minHeight: '48px',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.geoColors.headerText.main,
    userSelect: 'none',
    zIndex: 0
  }
}))
